export default __webpack_public_path__ + "static/media/image1.31ab0a76.png";